import React from "react";
import { Route, Redirect } from "react-router-dom";
import { usePermissions } from "../Utility/PermissionContext";
import { hasAccess } from "./AccessUtils";

const ProtectedRoute = ({ component: Component, path, ...rest }) => {
  const { subscriptionData, role } = usePermissions();
  const access = hasAccess(subscriptionData, role, path);

  return (
    <Route
      path={path}
      render={(props) => {
        if (!access.allowed && role === "user") {
          return <Redirect to="/NoAccessPage" />;
        }
        return <Component {...props} />;
      }}
      {...rest}
    />
  );
};

export default ProtectedRoute;